
document.head.innerHTML += '<link rel="stylesheet" href="https://mf3yh7-ab.myshopify.com/cdn/shop/t/2/assets/game_style.css" type="text/css"/>';
  
// set load variables
var load_image_urls = new Array();
var loaded_images = new Array();
var load_error = 0; // 0 is no error found during loading
var load_error_codes = "Loading;Unknown region, check your URL;Failed to load image :(";
load_error_codes = load_error_codes.split(";");
document.getElementById("tic_load_text").textContent = load_error_codes[0];

// Overview of all mission characteristics
// [x, y, type, region]
var mission_settings = [["1760","700","subwaystress","kl"],
                            ["1760","590","subwaystress","bk"],
                            ["1840","530","subwaystress","hk"],
                            ["1930","660","landmarking","sea"],
                            ["1840","420","landmarking","ea"],
                            ["1180","485","landmarking","na"],
                            ["1070","335","landmarking","eu"],
                            ["2100","830","cuisinecatch","gui"],
                            ["1990","450","cuisinecatch","jap"],
                            ["400","650","cuisinecatch","cos"],
                            ["1175","970","puzzling","sa"],
                            ["2030","1025","puzzling","au"],
                            ["570","800","puzzling","bra"]
                        ];
    
// e.g. /game_level?level=0

// check the game settings
var game_region = "";
var mission_number = "";

// read cookies to get player saved data
var decodedCookie = decodeURIComponent(document.cookie);
var ca = decodedCookie.split(';');

function getCookie(cname) {
  var name = cname + "=";
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') { c = c.substring(1); }
      if (c.indexOf(name) == 0) { return c.substring(name.length, c.length); }
  	}
  	return "";
}

// load audio preferences
var audio_enabled = getCookie("tic_game_audio");
var audio_playing = "no"; // keep track if the in game or map music already started playing

// load game progress
var game_progress = getCookie("tic_game_progress");
  
if(game_progress == null || game_progress == "") { // no saved data yet
  game_progress = [0,0,0,0,0,0,0,0,0,0,0,0]; // 12 missions
} else {
  game_progress = game_progress.split(",");
}

if(game_type == "level") { // a level
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  game_type = urlParams.get('level');
  mission_number = parseInt(game_type);
  if(mission_number < mission_settings.length) {
    game_type = mission_settings[mission_number][2];
    game_region = mission_settings[mission_number][3];
  } else {
    load_error = 1; // level does not exist
  }
}

	function check_load_state() {
      	if(load_error > 0) { // we encountered an error, stop loading
          	document.getElementById("tic_load_text").textContent = load_error_codes[load_error];
          	document.getElementById("tic_load_icon").className = "load_error";
          	document.getElementsByClassName("ingame_menu_btn")[0].style.display = "block";
        } else if(loaded_images.length == load_image_urls.length) { // finished loading!
			document.getElementById("tic_load_box").style.display = "none";
          	document.getElementById("tic_game_container").style.display = "block";
          	var game_box = document.getElementById("tic_game_box");
			if(game_type == "landmarking") { set_lm_level(); }
          	if(game_type == "subwaystress") {
           		var new_image = loaded_images[0];
                new_image.id = "ss_image_box";
                game_box.appendChild(new_image);
            }
          	if(game_type == "cuisinecatch") {
              	set_kitchen();
            }
          	if(game_type == "menu") {
           		var new_image = loaded_images[mission_settings.length];
                new_image.id = "menu_map_image";
                document.getElementById("map_container").appendChild(new_image);
              	zoom_map();
                if(ticworld_completed > 0 || document.referrer.includes("pop-up=yes") == true){
                  open_pop("message");
                }
            } else {
                if(game_type == "puzzling") {
                	document.getElementById("tic_game_box").classList.add("puzzle_mode");
                    setPuzzle();
                    size_container(game_box, "500", "500");
                } else {
                    size_container(game_box, "1086", "529");
                }
            } 	
        } else { // continue loading images
        	load_asset();  
        }
    }

	function load_asset() {
        var asset = new Image();
        asset.onload = function() {
          loaded_images.push(asset);
    	  check_load_state();
        }
    	asset.onerror = function() { load_error = 2; check_load_state(); }
		asset.src = load_image_urls[loaded_images.length];
    }

	var cc_x_correction = 1; // corrections for the cuisine catch game meal move
	var cc_x_margin = 0;

	function size_container(object, object_width, object_height) {
        document.body.style.width = document.documentElement.clientWidth + "px";
        document.body.style.height = document.documentElement.clientHeight + "px";
    	var window_ratio = document.documentElement.clientWidth / document.documentElement.clientHeight;
        var map_scale = document.documentElement.clientWidth / object_width;
        if(map_scale > 1) { map_scale = 1; }
        if(window_ratio > 1.7) {
           	map_scale = document.documentElement.clientHeight / object_height;
          	if(map_scale > 1) { map_scale = 1; }
           	var margin = document.documentElement.clientWidth - (object_width * map_scale);
            if(margin < 0) { margin = 0; }
          	cc_x_margin = margin / 2;
           	object.style.margin = "0px " + margin / 2 + "px";
        } else {
            object.style.margin = "";
        }
      	cc_x_correction = 1 / map_scale;
        object.style.transform = "scale(" + map_scale + ")";
    }

    window.addEventListener("load", (event) => {
      check_load_state(); // load assets and game
    });

    // reset game box when orientation changes
    
    window.screen.orientation.onchange = orientationChange = () => {
        if(game_type == "menu") {
          var size_box = document.getElementById("map_container");
          size_container(size_box, "2400", "1400");
        } else {
          var size_box = document.getElementById("tic_game_box");
          if(game_type == "puzzling") {
            size_container(size_box, "500", "500");
          } else {
            size_container(size_box, "1086", "529");
          }
        }
    };
    
    